import React from 'react';
import useAppSelector from '../../app/redux/useAppSelector';
import { CREATION_ID } from '../../editor/editorSlice';
import CommentThreadCompactAvatarStack from './CommentThreadCompactAvatarStack';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';

export const MINIMIZED_COMMENT_HEIGHT = 34;

const THREAD_FRAGMENT = gql(`
  fragment CommentThreadMinimized_thread on PublicThreadFields {
    id
    comments {
      id
      ...CommentThreadCompactAvatarStack_comment
    }
  }
`);

interface CommentThreadMinimizedProps {
  thread: DocumentType<typeof THREAD_FRAGMENT>;
}

const CommentThreadMinimized = ({ thread }: CommentThreadMinimizedProps) => {
  const currentUser = useAppSelector((state) => state.session.user);

  return (
    <CommentThreadCompactAvatarStack
      comments={
        thread.id === CREATION_ID
          ? [{ id: currentUser.id, author: currentUser }]
          : thread.comments.slice(0, 1)
      }
      ring={false}
    />
  );
};

export default CommentThreadMinimized;
